import React, { useEffect, useState } from "react";
import { View, StyleSheet, SafeAreaView, TouchableOpacity } from "react-native";
import Slider from "@react-native-community/slider";

import Separator from "./Separator";
import Text from "component/typography/Text";
import Button from "component/button/Button";
import Modal from "component/picker/Modal";

import { colors, sizes, strings } from "asset/constant";
import { css } from "style";
import { mq } from "utils";

const total = (c: number) => 10 - (c % 10) + c;

export default function CartCountSlider(props: {
  step: number;
  visible?: boolean;
  hide: () => void;
  onApply: (count: number) => void;
  count: number;
}) {
  const { hide, visible, count, onApply, step } = props;

  const [countState, setCountState] = useState(Number(count));

  useEffect(() => {
    setCountState(Number(count));
  }, [count]);

  const _onShow = () => setCountState(Number(count));

  const _onPlus = () => setCountState((prev) => prev + step);
  const _onMinus = () => setCountState((prev) => prev - step);

  const _onApply = () => {
    hide();
    onApply(countState);
  };

  return (
    <Modal onShow={_onShow} visible={visible} close={hide}>
      <SafeAreaView style={styles.container}>
        <TouchableOpacity
          style={css.container}
          activeOpacity={1}
          onPress={hide}
        />
        <View style={styles.box}>
          <View style={{ ...css.rRowCenterAlign }}>
            <View
              style={{
                ...css.square(48),
                ...css.centralElements,
                backgroundColor: colors.theme,
                borderRadius: sizes.radius.lg,
              }}
            >
              <Text size={"xxxl"} weight="extraBold" color={colors.white}>
                {countState}
              </Text>
            </View>
            <View style={css.container}>
              <Button
                onPress={_onApply}
                width={"90%"}
                style={{ ...css.selfStart }}
                title={{ value: strings.apply_to_cart }}
              />
            </View>
          </View>

          <Separator transparent size={mq(20)} />

          <View style={styles.sliderContainer}>
            <TouchableOpacity
              onPress={countState > step ? _onMinus : undefined}
              activeOpacity={sizes.tapOpacity}
              style={{
                ...css.size(40, 50),
                ...css.centralElements,
                borderRadius: 15,
                backgroundColor: colors.bg.light,
              }}
            >
              <Text
                color={colors.text.gray}
                weight="extraBold"
                align="center"
                size={"lg"}
              >
                {step}
              </Text>
            </TouchableOpacity>

            <View style={{ width: 10 }} />

            <Slider
              step={step}
              style={css.container}
              minimumValue={step}
              value={countState ?? count}
              onValueChange={setCountState}
              thumbTintColor={colors.theme}
              minimumTrackTintColor={colors.theme}
              maximumValue={10 - (count % 10) + count}
            />

            <View style={{ width: 10 }} />

            <TouchableOpacity
              onPress={countState < total(count) ? _onPlus : undefined}
              activeOpacity={sizes.tapOpacity}
              style={{
                ...css.size(40, 50),
                ...css.centralElements,
                borderRadius: 15,
                backgroundColor: colors.bg.light,
              }}
            >
              <Text
                color={colors.text.gray}
                weight="extraBold"
                align="center"
                size={"lg"}
              >
                {total(count)}
              </Text>
            </TouchableOpacity>
          </View>

          <Separator transparent />
          <Text align="center" weight="bold" color={colors.text.muted}>
            مقدار دلخواه را انتخاب کرده و «اعمال به سبد خرید» را بزنید
          </Text>
        </View>
      </SafeAreaView>
    </Modal>
  );
}

const styles = StyleSheet.create({
  container: {
    ...css.container,
  },

  box: {
    borderTopRightRadius: sizes.radius.lg,
    borderTopLeftRadius: sizes.radius.lg,
    backgroundColor: colors.white,
    paddingHorizontal: mq(20),
    paddingVertical: mq(25),
  },

  count: { alignSelf: "center" },

  sliderContainer: {
    height: mq(50),
    ...css.rowCenterAlign,
    justifyContent: "center",
    borderRadius: sizes.radius.lg,
  },
});
